// extracted by mini-css-extract-plugin
export var content = "_ab-3";
export var list = "_ab-4";
export var settingsContent = "_ab-7";
export var settingsPanel = "_ab-8";
export var state = "_ab-6";
export var triggerBadge = "_ab-2";
export var triggerButton = "_ab-1";
export var triggerShell = "_ab-0";
export var unreadDot = "_ab-5";